import { Registry } from 'InterfaceBundle'

/**
 * Style
 */

/**
 * Components
 */
import BlFormFieldPackaging from './components/FormFieldPackaging.vue'

Registry.components(BlFormFieldPackaging)

/**
 * Directives
 */

/**
 * Services
 */